import ApiConstants from "../../constants/ApiConstants";
import http from "../../http";

class INComplianceService {
    static getITDeclarationConfig() {
        return http.get(ApiConstants.URL.BASE + ApiConstants.URL.COMPLIANCE.IN.GET_IT_DECLARATION_CONFIG)
        .catch((error: any) => {
            console.error('Error while fetching IT Declaration config: ', error);
            return Promise.reject(error);
        });
    }

    static setITDeclarationConfig(payload) {
        return http.patch(ApiConstants.URL.BASE + ApiConstants.URL.COMPLIANCE.IN.GET_IT_DECLARATION_CONFIG, payload)
        .catch((error: any) => {
            console.error('Error while updating IT Declaration config: ', error);
            return Promise.reject(error);
        });
    }

    static enableBooksIntegration(payload) {
        return http.patch(ApiConstants.URL.BASE + ApiConstants.URL.COMPLIANCE.IN.TOGGLE_INTEGRATION_MAPPING, payload)
        .catch((error: any) => {
            console.error('Error while enabling Books Integration: ', error);
            return Promise.reject(error);
        });
    }

    static getBooksIntegrationMappingDetails() {
        return http.get(ApiConstants.URL.BASE + ApiConstants.URL.COMPLIANCE.IN.GET_INTEGRATION_MAPPING)
        .catch((error: any) => {
            console.error('Error while fetching Integration Settings ', error);
            return Promise.reject(error);
        });
    } 

    static getExpenseAndLiabilityAccountGroups() {
        return http.get(ApiConstants.URL.BASE + ApiConstants.URL.COMPLIANCE.IN.GET_EXPENSE_AND_LIABILITY_ACCOUNTS)
        .catch((error: any) => {
            console.error('Error while fetching Expense and Liability Accounts ', error);
            return Promise.reject(error);
        });
    } 

    static getTaxDeclarationItems() {
        return http.get(ApiConstants.URL.BASE + ApiConstants.URL.COMPLIANCE.IN.GET_TAX_DECLARATION_ITEMS)
        .catch((error: any) => {
            console.error('Error while fetching IT Declaration config: ', error);
            return Promise.reject(error);
        });
    }

    static getITDeclaration(params) {
        return http.get(ApiConstants.URL.BASE + ApiConstants.URL.COMPLIANCE.IN.GET_IT_DECLARATION, { params: params })
        .catch((error: any) => {
            console.error('Error while fetching IT Declaration: ', error);
            return Promise.reject(error);
        });
    }

    static saveITDeclaration(payload, params) {
        return http.post(ApiConstants.URL.BASE + ApiConstants.URL.COMPLIANCE.IN.GET_IT_DECLARATION, payload, { params: params })
        .catch((error: any) => {
            console.error('Error while saving IT Declaration: ', error);
            return Promise.reject(error);
        });
    }

    static updateITDeclaration(payload, params) {
        return http.put(ApiConstants.URL.BASE + ApiConstants.URL.COMPLIANCE.IN.GET_IT_DECLARATION, payload, { params: params })
        .catch((error: any) => {
            console.error('Error while updating IT Declaration: ', error);
            return Promise.reject(error);
        });
    }

    static getTaxEstimation(params) {
        return http.get(ApiConstants.URL.BASE + ApiConstants.URL.COMPLIANCE.IN.GET_TAX_ESTIMATE, { params: params })
        .catch((error: any) => {
            console.error('Error while getting tax estimation: ', error);
            return Promise.reject(error);
        });
    }
}

export default INComplianceService;
